import { useQuery } from "@tanstack/react-query";

import { makeApiRequest } from "../../utils";
import { SPENDING_AGGREGATIONS_QUERY_KEY } from "../../../constants/queryKeys";

export const useFetchSpendingAggregations = ({
  direction = "All",
  name = ""
}) => {
  const searchParams = new URLSearchParams({
    name,
    direction: direction === "All" ? "" : direction
  }).toString();

  return useQuery({
    queryKey: [SPENDING_AGGREGATIONS_QUERY_KEY, searchParams],
    queryFn: async () => {
      return makeApiRequest({
        endpoint: `/api/spendingAggregations?${searchParams}`,
        method: "GET"
      });
    },
    keepPreviousData: true
  });
};
